import { createContext, useContext, useMemo } from "react";
import { Outlet } from "react-router-dom";

import { useAuthContext } from "@covertree/auth";

interface WholesalerProviderState {
  isWholesaler: boolean;
}

const initialState: WholesalerProviderState = {
  isWholesaler: false,
};

const WholesalerContext = createContext<WholesalerProviderState>(initialState);

export const useWholesalerContext = () => useContext(WholesalerContext);

const WholesalerProvider = () => {
  const { tokenPayload } = useAuthContext();

  const isWholesaler = useMemo<boolean>(() => {
    if (!tokenPayload) return false;

    const isWholesalerFromToken = tokenPayload.isWholesaler;

    return isWholesalerFromToken ? isWholesalerFromToken === "true" : false;
  }, [tokenPayload]);

  return (
    <WholesalerContext.Provider value={{ isWholesaler }}>
      <Outlet />
    </WholesalerContext.Provider>
  );
};

export default WholesalerProvider;
